import React from "react";
import { Flex, Button } from "@chatui/core";
import { renderText } from '../utils/util';
import { searchObj } from '../utils/util';
import "./questionnaire.css";
let { theme , game_id, gta_version_ios, sdkVersion } = searchObj(window.location.search)
gta_version_ios = gta_version_ios ? gta_version_ios : sdkVersion
const QuestionEvaluate = (props) => {
	return (
		<>
			<Flex center style={{ padding: "3px" }}>
				<Button
					className={`submitBtn`}
					block
					color="primary"
					onClick={() =>{
						if(window.location.hostname.indexOf('gtarcade') > -1){
							if(window.location.hostname.indexOf('prv') > -1){
								window.location.href = "https://qamsupport.gtarcade.com/default/verify" + props.location.search + `&callback_url=${encodeURIComponent('http://qasupport.gtarcade.com/aiservice/search/choose-form?gid=' + game_id + '&theme=' + theme + (gta_version_ios ? ('&gta_version_ios=' + gta_version_ios) : ''))}`
							} else {
								window.location.href = "https://msupport.gtarcade.com/default/verify" + props.location.search + `&callback_url=${encodeURIComponent('http://support.gtarcade.com/aiservice/search/choose-form?gid=' + game_id + '&theme=' + theme + (gta_version_ios ? ('&gta_version_ios=' + gta_version_ios) : ''))}`
							}
						} else {
							props.history.push({
								pathname: "/workOrderList",
								search: props.location.search,
							})
						}
					}
					}
				>
					{renderText('return_ask')}
				</Button>
			</Flex>
		</>
	);
};

export default QuestionEvaluate;
